import { MaintenanceWindowPatchManagementVendorProductSelectorController } from '../controller/MaintenanceWindowPatchManagementVendorProductSelectorController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { VendorProductsPair } from '../types';

export class MaintenanceWindowPatchManagementVendorProductSelectorWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowPatchManagementVendorProductSelectorController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowPatchManagementVendorProductSelectorController,
    });
  }

  private vendorProductsPairsDataAttributeName = 'data-vendor-products-pairs';

  get vendorProductsPairs(): VendorProductsPair[] {
    const attributeValue = this.getAttribute(this.vendorProductsPairsDataAttributeName);

    return attributeValue ? JSON.parse(attributeValue) : [];
  }

  set vendorProductsPairs(value: VendorProductsPair[]) {
    this.setAttribute(this.vendorProductsPairsDataAttributeName, JSON.stringify(value));
    if (this.controller) {
      this.controller.resetFormControls();

      if (this.controller.view.dom.$grid) {
        // Re-render grid
        this.controller.view.dom.$grid.propertiesSet = true;
      }
    }
  }

  get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');

    if (attributeValue !== null) {
      return true;
    }

    return false;
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
  }
}
